import {useGraphql} from "@/core/graphql/service"

import {genqlBuilder} from "@/core/graphql/genql/builder"

import {QueryGenqlSelection, Query} from "../schema"

export type QueryFortunePrizesVars = {}

export type FortunePrizesResult = Query['fortune_prizes']

export function fortunePrizesQuery(query: QueryGenqlSelection['fortune_prizes'] | null) {
      
    const build = (variables: QueryFortunePrizesVars) => genqlBuilder.build(query ? {fortune_prizes: query} : {__scalar: true}, {fortune_prizes: variables})
    const run = (variables: QueryFortunePrizesVars | null = null): Promise<FortunePrizesResult | null> => {
        const {queryWrapped} = useGraphql()
        return queryWrapped(build(variables || {}))
    }
                
    return {
      build,  
      run,
      _variables: {} as QueryFortunePrizesVars,
      _result: {} as FortunePrizesResult,
    }
}

export default fortunePrizesQuery